import React, { useMemo, useCallback } from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import {
  shortProviderSubtitle,
  transformProviderNameWithTitle,
} from '../../../../utils/appointments/provider-details-formatter';
import ProviderNameAvatar from '../../Components/ProviderNameAvatar';
import Shape from '../../../common/Shape';
import styles from './styles.styl';

function ProviderInfo({ provider, languageTypes }) {
  const renderProviderSubTitle = useCallback(shortProviderSubtitle, []);
  const providerDetails = useMemo(
    () => transformProviderNameWithTitle(provider),
    [provider],
  );
  const { organization, specialization, languages = [], greeting } = provider;
  const organizationLogo = get(organization, 'logo.thumbMiddle');

  const languageString = useMemo(
    () =>
      languages
        .map(key => {
          const matched = languageTypes.find(({ value }) => key === value);
          return matched ? matched.label : key;
        })
        .join(', '),
    [languages, languageTypes],
  );

  return (
    <Shape styleName="root">
      <div styleName="row">
        <ProviderNameAvatar
          withoutLocation
          provider={providerDetails}
          renderMeta={renderProviderSubTitle}
        />
        <div styleName="right">
          {organizationLogo && <img src={organizationLogo} styleName="logo" />}
        </div>
      </div>
      <div styleName="row align-top">
        <div styleName="info-block">
          <span styleName="info-title">
            <FormattedMessage id="appointments.specialization" />:
          </span>
          <span styleName="meta">{specialization || '-'}</span>
        </div>
        <div styleName="info-block">
          <span styleName="info-title">
            <FormattedMessage id="profile.fields.language" />:
          </span>
          <span styleName="meta">{languageString || '-'}</span>
        </div>
      </div>
      <div styleName="description">{greeting}</div>
    </Shape>
  );
}

ProviderInfo.propTypes = {
  provider: PropTypes.object,
  languageTypes: PropTypes.array,
};

export default CSSModules(ProviderInfo, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviderDetails/ProviderInfo/index.jsx